module.exports = __webpack_public_path__ + "/login_ui/img/ru-764a16d2d2458caa580fbe057ef3a129.svg";